import React from 'react'
import LapKeuanganPage from '../../modules/admintbk/LapKeuanganPage'

const LaporanKeuanga = () =>{
  return (
    <LapKeuanganPage></LapKeuanganPage>
    )
}

export default LaporanKeuanga